import type { NavAccountType } from "@admin-ui/components/frames/AdminLayout";
import { usePage } from "@inertiajs/react";
import type { SharedProps } from "@/types";

export function useAdminLayoutAccount(): NavAccountType {
  const { current_user } = usePage<SharedProps>().props;

  return {
    id: String(current_user?.id ?? ""),
    name: (current_user?.name ?? current_user?.email) as string,
    email: current_user?.email ?? "",
    avatar: current_user?.avatar?.src ?? "",
    status: "online",
  };
}
